export const ticketsRouteNames = {
  root: 'user.tickets',
  resolveNavigation: 'user.tickets.for-resolver',
  gettingStarted: 'user.tickets.getting-started',
  tableFilteredView: 'user.tickets.table.fv',
  ticketDetails: 'user.tickets.details',
} as const satisfies Record<string, string>
